export const text = {
  Agenda: "Agenda",
  AddEventType: "Evenementtype toevoegen",
  AddCalendarEvent: "Agenda evenement toevoegen",
  EventType: "Evenementtype",
  CalendarEvent: "Agenda evenement",
  StartDateTime: "Startdatum en tijd",
  EndDateTime: "Einddatum en tijd",
  CalendarEventaddedsuccessfully: "Agenda evenement succesvol toegevoegd",
  CalendarEventupdatedsuccessfully: "CAgenda evenement succesvol bijgewerkt",
  CalendarEventDeletedsuccessfully: "Agenda evenement succesvol verwijderd",
  EventTypeaddedsuccessfully: "Evenementtype succesvol toegevoegd",
  EventTypeupdatedsuccessfully: "Evenementtype succesvol bijgewerkt",
  EventTypeDeletedsuccessfully: "Evenementtype succesvol verwijderd",
  Entertheeventtype: "Voer het gebeurtenistype in",
};
